import * as Oidc from 'oidc-client-ts';
import * as React from 'react';

import { Settings } from '../Settings';

export class SilentRenewComponent extends React.Component<any, any> {
  componentDidMount() {
    const manager = new Oidc.UserManager(Settings);

    manager.signinSilentCallback().catch((err) => {
      console.error('Silent renew callback error:', err);
    });
  }

  render() {
    return null;
  }
}

export default SilentRenewComponent;
